// extracted by mini-css-extract-plugin
export default {"selectTimeGroupBox":"SelectTimeGroup_selectTimeGroupBox__wBfbh"};